import { Box, Divider, Stack } from '@mui/material';
import { editor } from 'monaco-editor';
import Controller from '../../../Components/Drawers/Controller/Controller';
import ControllerZeroHeading from '../../../Components/Drawers/Controller/ControllerZeroHeading';
import TreeSitterInputBindingStatus from '../../../Components/Drawers/Controller/TreeSitterInputBindingStatus';
import { ActionMappingControlList } from '../../Drawers/Controller/ActionMappingControlList';
import { usePythonTreeSitterReady } from '../../../hooks/editor/usePythonTreeSitterReady';
import { INPUT_BINDING_DEVICE } from '../../../utils/inputBindings';

const { CONTROLLER } = INPUT_BINDING_DEVICE;

interface ControllerConfigurationTabProps {
  editor?: editor.IStandaloneCodeEditor;
}

const ControllerConfigurationTab: React.FC<ControllerConfigurationTabProps> = ({ editor }) => {
  const treeSitterStatus = usePythonTreeSitterReady();

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="column" spacing={2}>
        <TreeSitterInputBindingStatus status={treeSitterStatus} />
        <Box
          width="100%"
          alignSelf="center"
          textAlign="center"
          sx={{
            // Make the controller SVG responsive up to 300px, then fixed
            '& svg': { width: '100%', maxWidth: 300, height: 'auto' },
          }}
        >
          <Controller editor={editor} mappingsReady={treeSitterStatus.mappingsReady} />
        </Box>
        <ControllerZeroHeading />
        <Divider />
        <ActionMappingControlList device={CONTROLLER} editor={editor} mappingsReady={treeSitterStatus.mappingsReady} />
      </Stack>
    </Box>
  );
};

export default ControllerConfigurationTab;
